const card = {
  props: {
    dynamicClass: ".c-card.dynamicLoading",
    ctaSelectorDesktop: ".text-desktop-JS",
    ctaSelectorMobile: ".text-mobile-JS",
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-card.css", this.props.dynamicClass);

    const baseFind = baseDom ? baseDom : document,
      elementsTextDesktop = baseFind.querySelectorAll(this.props.ctaSelectorDesktop),
      elementsTextMobile = baseFind.querySelectorAll(this.props.ctaSelectorMobile);

    elementsTextDesktop && elementsTextMobile && this.initText(elementsTextDesktop, elementsTextMobile);
  },

  initText: function (elementsTextDesktop, elementsTextMobile) {
    if (bcl.u.mobile.isMobile()) {
      bcl.u.showElements(elementsTextMobile);
      bcl.u.hiddeElements(elementsTextDesktop);
    } else {
      bcl.u.showElements(elementsTextDesktop);
      bcl.u.hiddeElements(elementsTextMobile);
    }
  },
};

export default card;
